/**
 * Copiar um texto para a área de transferência, dizendo se deu certo.
 *
 * O `navigator.clipboard` só existe em contexto seguro (HTTPS ou `localhost`) e pode recusar o
 * pedido (permissão negada, aba sem foco): as duas causas viram `false`, e quem chamou decide o
 * que dizer — o card do Funil e o cartão de ID do negócio (11.4) mostram o mesmo toast.
 */
export async function copiarParaAreaDeTransferencia(texto: string): Promise<boolean> {
  const areaDeTransferencia = navigator.clipboard as Clipboard | undefined
  if (areaDeTransferencia === undefined) {
    return false
  }
  try {
    await areaDeTransferencia.writeText(texto)
    return true
  } catch {
    return false
  }
}

/**
 * O ícone de copiar (duas folhas sobrepostas), desenhado em SVG e não em caractere: o `⧉` do
 * protótipo depende de a fonte instalada ter o glifo, e num navegador sem ele vira um quadrado.
 * É decorativo — o nome acessível está no botão que o carrega.
 */
export function IconeDeCopiar() {
  return (
    <svg
      className="icone-de-copiar"
      viewBox="0 0 16 16"
      width="12"
      height="12"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M10.5 5.5V3.5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2" fill="none" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}
